import { render, staticRenderFns } from "./Builds.vue?vue&type=template&id=04930f33&scoped=true&"
import script from "./Builds.vue?vue&type=script&lang=js&"
export * from "./Builds.vue?vue&type=script&lang=js&"
import style0 from "./Builds.vue?vue&type=style&index=0&id=04930f33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04930f33",
  null
  
)

export default component.exports